import { useState } from "react"
import TooltipComponent from "../components/tooltip"
import { AiFillStar } from "react-icons/ai"
import UserModal from '../components/Modal'
import modalImage from "../assets/modal_img.png"
import defaultUser from "../assets/defaultUser.png";



function Favourite() {

    const [modalItem, setModalItem] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };

    return (
        <>
            <section className='favourite_sec'>
                <div className="container">
                    <h3>Favourite Producers</h3>

                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                            <div className="card h-100">
                                <div className="content">
                                    <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                    <h5>User 1</h5>

                                    <UserModal btnText="View" id={`View1`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                        <div className='d-flex jc-between ai-center modal_header'>
                                            <div className='d-flex ai-center'>
                                                <img src={modalImage} alt="image" className='img-fluid' />
                                                <div className='mx-3'>
                                                    <h5>User 1</h5>
                                                    <small>100 orders</small>
                                                </div>
                                            </div>
                                            <div className='text-center'>
                                                <TooltipComponent className="" placement="bottom" tooltipText="Favourite">
                                                    <span>
                                                        <AiFillStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </div>
                                        <div className='mb-4'>
                                            <small>Other details will add according to system and it's data</small>
                                        </div>
                                        <div>
                                            <h6>Terms and conditions</h6>
                                            <small>No third-party payment. Thank you</small>
                                        </div>

                                    </UserModal>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                            <div className="card h-100">
                                <div className="content">
                                    <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                    <h5>User 2</h5>

                                    <UserModal btnText="View" id={`View2`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                        <div className='d-flex jc-between ai-center modal_header'>
                                            <div className='d-flex ai-center'>
                                                <img src={modalImage} alt="image" className='img-fluid' />
                                                <div className='mx-3'>
                                                    <h5>User 2</h5>
                                                    <small>200 orders</small>
                                                </div>
                                            </div>
                                            <div className='text-center'>
                                                <TooltipComponent className="" placement="bottom" tooltipText="Favourite">
                                                    <span>
                                                        <AiFillStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </div>
                                        <div className='mb-4'>
                                            <small>Other details will add according to system and it's data</small>
                                        </div>
                                        <div>
                                            <h6>Terms and conditions</h6>
                                            <small>No third-party payment. Thank you</small>
                                        </div>

                                    </UserModal>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                            <div className="card h-100">
                                <div className="content">
                                    <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                    <h5>User 3</h5>

                                    <UserModal btnText="View" id={`View3`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                        <div className='d-flex jc-between ai-center modal_header'>
                                            <div className='d-flex ai-center'>
                                                <img src={modalImage} alt="image" className='img-fluid' />
                                                <div className='mx-3'>
                                                    <h5>User 3</h5>
                                                    <small>200 orders</small>
                                                </div>
                                            </div>
                                            <div className='text-center'>
                                                <TooltipComponent className="" placement="bottom" tooltipText="Favourite">
                                                    <span>
                                                        <AiFillStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </div>
                                        <div className='mb-4'>
                                            <small>Other details will add according to system and it's data</small>
                                        </div>
                                        <div>
                                            <h6>Terms and conditions</h6>
                                            <small>No third-party payment. Thank you</small>
                                        </div>

                                    </UserModal>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                            <div className="card h-100">
                                <div className="content">
                                    <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                    <h5>User 4</h5>

                                    <UserModal btnText="View" id={`View4`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                        <div className='d-flex jc-between ai-center modal_header'>
                                            <div className='d-flex ai-center'>
                                                <img src={modalImage} alt="image" className='img-fluid' />
                                                <div className='mx-3'>
                                                    <h5>User 4</h5>
                                                    <small>200 orders</small>
                                                </div>
                                            </div>
                                            <div className='text-center'>
                                                <TooltipComponent className="" placement="bottom" tooltipText="Favourite">
                                                    <span>
                                                        <AiFillStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </div>
                                        <div className='mb-4'>
                                            <small>Other details will add according to system and it's data</small>
                                        </div>
                                        <div>
                                            <h6>Terms and conditions</h6>
                                            <small>No third-party payment. Thank you</small>
                                        </div>

                                    </UserModal>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Favourite
